/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityFindingsAggAsset } from './ControlEntityFindingsAggAsset';
import {
    ControlEntityFindingsAggAssetFromJSON,
    ControlEntityFindingsAggAssetFromJSONTyped,
    ControlEntityFindingsAggAssetToJSON,
} from './ControlEntityFindingsAggAsset';
import type { ControlResolutionRequestStatus } from './ControlResolutionRequestStatus';
import {
    ControlResolutionRequestStatusFromJSON,
    ControlResolutionRequestStatusFromJSONTyped,
    ControlResolutionRequestStatusToJSON,
} from './ControlResolutionRequestStatus';
import type { ControlResolutionTypes } from './ControlResolutionTypes';
import {
    ControlResolutionTypesFromJSON,
    ControlResolutionTypesFromJSONTyped,
    ControlResolutionTypesToJSON,
} from './ControlResolutionTypes';

/**
 * 
 * @export
 * @interface ControlEntityFindingsAggResult
 */
export interface ControlEntityFindingsAggResult {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAggResult
     */
    datapoint?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAggResult
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityFindingsAggResult
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAggResult
     */
    level?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAggResult
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAggResult
     */
    score_category?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAggResult
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityFindingsAggResult
     */
    recommendation?: Array<string>;
    /**
     * 
     * @type {Array<ControlResolutionTypes>}
     * @memberof ControlEntityFindingsAggResult
     */
    resolution_types?: Array<ControlResolutionTypes>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityFindingsAggResult
     */
    references?: Array<string>;
    /**
     * 
     * @type {Array<ControlEntityFindingsAggAsset>}
     * @memberof ControlEntityFindingsAggResult
     */
    assets?: Array<ControlEntityFindingsAggAsset>;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityFindingsAggResult
     */
    first_seen?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityFindingsAggResult
     */
    last_seen?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityFindingsAggResult
     */
    risk_score?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAggResult
     */
    muted_status?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityFindingsAggResult
     */
    scan_status?: string;
    /**
     * 
     * @type {ControlResolutionRequestStatus}
     * @memberof ControlEntityFindingsAggResult
     */
    resolution_status?: ControlResolutionRequestStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEntityFindingsAggResult
     */
    is_contingency?: boolean;
}

/**
 * Check if a given object implements the ControlEntityFindingsAggResult interface.
 */
export function instanceOfControlEntityFindingsAggResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityFindingsAggResultFromJSON(json: any): ControlEntityFindingsAggResult {
    return ControlEntityFindingsAggResultFromJSONTyped(json, false);
}

export function ControlEntityFindingsAggResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityFindingsAggResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'datapoint': !exists(json, 'datapoint') ? undefined : json['datapoint'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'score_category': !exists(json, 'score_category') ? undefined : json['score_category'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'recommendation': !exists(json, 'recommendation') ? undefined : json['recommendation'],
        'resolution_types': !exists(json, 'resolution_types') ? undefined : ((json['resolution_types'] as Array<any>).map(ControlResolutionTypesFromJSON)),
        'references': !exists(json, 'references') ? undefined : json['references'],
        'assets': !exists(json, 'assets') ? undefined : ((json['assets'] as Array<any>).map(ControlEntityFindingsAggAssetFromJSON)),
        'first_seen': !exists(json, 'first_seen') ? undefined : json['first_seen'],
        'last_seen': !exists(json, 'last_seen') ? undefined : json['last_seen'],
        'risk_score': !exists(json, 'risk_score') ? undefined : json['risk_score'],
        'muted_status': !exists(json, 'muted_status') ? undefined : json['muted_status'],
        'scan_status': !exists(json, 'scan_status') ? undefined : json['scan_status'],
        'resolution_status': !exists(json, 'resolution_status') ? undefined : ControlResolutionRequestStatusFromJSON(json['resolution_status']),
        'is_contingency': !exists(json, 'is_contingency') ? undefined : json['is_contingency'],
    };
}

export function ControlEntityFindingsAggResultToJSON(value?: ControlEntityFindingsAggResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'datapoint': value.datapoint,
        'name': value.name,
        'count': value.count,
        'level': value.level,
        'category': value.category,
        'score_category': value.score_category,
        'description': value.description,
        'recommendation': value.recommendation,
        'resolution_types': value.resolution_types === undefined ? undefined : ((value.resolution_types as Array<any>).map(ControlResolutionTypesToJSON)),
        'references': value.references,
        'assets': value.assets === undefined ? undefined : ((value.assets as Array<any>).map(ControlEntityFindingsAggAssetToJSON)),
        'first_seen': value.first_seen,
        'last_seen': value.last_seen,
        'risk_score': value.risk_score,
        'muted_status': value.muted_status,
        'scan_status': value.scan_status,
        'resolution_status': ControlResolutionRequestStatusToJSON(value.resolution_status),
        'is_contingency': value.is_contingency,
    };
}

